export const PATCH_TYPE = {
    ADD: 'add',
    REMOVE: 'remove',
};

export const EDGE_TYPES = {
    MANUAL: 'manual',
    WITH_ADD_NODE: 'with-add-node',
};

// constants to help manual edge routing avoid crossing nodes
export const MANUAL_EDGE_ROUTING = Object.freeze({
    NODE_WIDTH: 263,
    NODE_HEIGHT: 82,
    BASELINE_CLEARANCE: 32,
    PERPENDICULAR_OFFSET: 32,
});

export const VERTICAL_SPLIT_OFFSET = 82;
